<template>
    <b-modal
        id="create-internship-tag-modal"
        modal-class="apprentice-default-modal create-internship-tag"
        ref="create-internship-tag-modal"
        size="md"
        :title="$t('internship.add_internship_type')"
        :ok-title="$t('common.add')"
        cancel-variant="outline-primary"
        :cancel-title="$t('common.cancel')"
        @show="load()"
        @ok="onOk">
        <div class="add-internship-type">
            <b-alert
                v-if="hasError"
                show
                variant="danger">
                {{ $t('internship.internship_type_cannot_be_empty') }}
            </b-alert>

            <b-form-group
                class="internship-tag-name"
                label-for="internship-tag-name-input"
                :label="$t('internship.name_internship_type')">
                <b-form-input
                    id="internship-tag-name-input"
                    v-model="name"
                    :placeholder="$t('internship.internship_type')">
                </b-form-input>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
import { ords } from '../../../../../app';

export default {
    name: 'design-2021-internship-tags-create-modal-component',
    data() {
        return {
            name: '',
            hasError: false,
        };
    },
    methods: {
        onOk(bvModalEvent) {
            this.hasError = false;

            if (this.name === '') {
                bvModalEvent.preventDefault();
                this.hasError = true;
                return;
            }

            let data = {
                name: this.name,
            };

            this.axios.post(this.routes.internshipTag(), data).then(
                (response) => {
                    ords.use('internshipTag').add(response.data);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        load() {
            this.name = '';
            this.hasError = false;
        },
    },
};
</script>

<style scoped lang="scss"></style>
